import React, { useEffect } from 'react';
import { useBeforeUnload } from 'react-use';
import { useNavigate } from 'react-router-dom';
import { captureException } from '@sentry/react';
import { isRaccoonError } from '@myhealth-raccoon/services';

import { useDispatch, useSelector } from 'src/store';
import { isRequestError } from 'src/utils/requestError';
import { useBookingFlowStep } from 'src/hooks/useBookingFlowStep';
import { bookingService } from 'src/services/booking';
import { ContentContainer } from 'src/components/ContentContainer';
import { PleaseWait } from 'src/components/PleaseWait';

type Props = { nextPage: string }

export function ConfirmBookingPassThrough({ nextPage }: Props) {
    useBookingFlowStep(3);
    const navigate = useNavigate();
    // show dialog before closing/reloading
    useBeforeUnload();
    const dispatch = useDispatch();

    const site_id = useSelector(state => state.appointment.clinicId)
    const { appointment_id } = useSelector(state => state.appointment.reservedBooking!);
    const codeRequestType = useSelector(state => state.bookingFlow.codeRequestType);

    useEffect(() => {
        (async () => {
            try {
                await bookingService.ConfirmBooking(site_id, appointment_id);
                navigate(nextPage, { replace: true });
            } catch (e) {
                if (e instanceof Error) {
                    // IF return reason = 4, then Booking was created, but something failed in sending confirmation. 
                    // IF return reason = 3 - the slot time has expired.
                    if (isRequestError(e) && isRaccoonError(e.data)) {
                        if (e.data.reason === 4) {
                            navigate(nextPage, { replace: true, state: { confirmNotifyFailed: true } });
                            return;
                        }
                        else if (e.data.reason === 3) {
                            navigate('/app/err-reserved-slot-expired', { replace: true });
                            return;
                        }
                    }
                    captureException(e)
                    navigate('/app/err-unexpected-error');
                }
            }
        })()
    }, [appointment_id, codeRequestType, navigate, site_id, nextPage, dispatch])

    return <ContentContainer>
        <PleaseWait />
    </ContentContainer>
}